/**
 * Angular imports.
 */
import { Component, OnInit, Output, EventEmitter, OnDestroy, Input } from '@angular/core';

/**
 * Service imports.
 */
import { GetService } from '../../../dataservices/get.service';
import { FunCollectionService } from '../../../common/common-functions/fun-collection.service';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { FilterPipe } from 'ngx-filter-pipe';
import { MultiLangService } from '../../../dataservices/master-service/multi-lang.service';
import { JwtDecodeService } from '../../../dataservices/jwt-decode.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';
import { PostingService } from '../posting.service';
/**
 * Interface import.
 */
import { AnalyticsInterface } from '../../../analytics-event/analytics.model';
/**
 * Constant import.
 */
import { EVENT_NAME } from './../../../analytics-event/analytics.constant';
import { SCREEN_NAME, COMMUNITY_LIST_TYPE, STATUS_CODE, NUMBERS, REPOST_STATUS, POST_TYPE, PRODUCT_TYPE_CONSTANT, FEED_KIND, MAPPED_PRODUCT_IN_COMMUNITY, PRODUCT_TYPE_CONSTANT_NAME, CTA_TYPE, ACTION_TYPE, ACTION_ON  } from '../../../constants/app.constants';
/**
 * Service imports.
 */
import { AnalyticsEventService } from './../../../analytics-event/analytics-event.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
import { ENTRY, EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';
import { ENETDOWN } from 'constants';

/**
 * Post Type Component
 */
@Component({
  selector: 'app-post-type',
  templateUrl: './post-type.component.html',
  styleUrls: ['./post-type.component.scss']
})
export class PostTypeComponent implements OnInit, OnDestroy {
  
  @Input() callingFrom: string;
  @Output() nextPostScreen = new EventEmitter();
  public speciality_list = [];
  public err_msg = '';
  public api_in_process = false;
  public showColor = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public userFilter: any = { speciality_name: '' };
  public is_data_posted = false;
  public timer = 0;
  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Analytics session time.
   */
  private sessiontime = { 'start_time': '', 'end_time': '' };
  /**
   * Analytics case type toggle event.
   */
  public analyticsDataCaseToggle: AnalyticsInterface;
  /**
   * Analytics next event object.
   */
  public analyticsDataCaseTypeNext: AnalyticsInterface;
  /**
   * Analytics entry event object.
   */
  private analyticsDataEntryEvent: AnalyticsInterface;
  /**
   * Analytics visit event object.
   */
  private analyticsVisitData: AnalyticsInterface;
  /**
   * Repost status object.
   */
  public repostStatus = REPOST_STATUS;

  /**
   * Necessary instances
   */
  constructor(
    private getSer: GetService,
    public fcs: FunCollectionService,
    public dss: DataStorageService,
    private filterPipe: FilterPipe,
    public multilang: MultiLangService,
    private jwtSer: JwtDecodeService,
    public mls: NewLanguageService,
    private analyticsEventService: AnalyticsEventService,
    private postingService: PostingService,
    private analyticSdk: Analytics
  ) { }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    if (this.dss.speciality_list == undefined || this.dss.speciality_list.length == 0 || this.dss.speciality_list == undefined || this.dss.speciality_list) {
      this.getSpecialityList();
    } else {
      if (this.dss.posting_data.screen2.selected_speciality.length == 0) {
        this.dss.posting_data.screen2.selected_speciality = this.dss.speciality_list.filter(x => x.is_primary == 1);
      }
      if (this.dss.posting_data.screen2.selected_speciality.length > 0 || this.dss.isRepostStatus === REPOST_STATUS.TWO) {
        this.showColor = true;
      } else {
        this.showColor = false;
      }
    }
    this.dss.user_association_list = [];
    this.getUserAssociation();
    if((MAPPED_PRODUCT_IN_COMMUNITY.indexOf(this.dss.repostProductType) !== -1) || !this.dss.repostProductType) {
      this.getUserCommunity();
    }

    /**
     * Set analytics data for case toggle event.
     */
    this.analyticsDataCaseToggle = {
      'event_name': EVENT_NAME.POST_CASETOGGLE_CLICK,
      'product_type': 0,
      'product_type_id': 0,
      'screen_name': SCREEN_NAME.POST_TYPE
    };
    /**
     * Set analytics data for case type event.
     */
    this.analyticsDataCaseTypeNext = {
      'event_name': EVENT_NAME.POST_CASETYPE_NEXT_CLICK,
      'product_type': 0,
      'product_type_id': 0,
      'screen_name': SCREEN_NAME.POST_TYPE
    };
    /**
     * Set analytics start time.
     */
    this.sessiontime.start_time = new Date().getTime().toString();
    /**
     * Set analytics data for analytics event.
     */
    const entryData: ENTRY = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.POSTING,
      entity_code: this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0',
      source: this.callingFrom,
      current_screen_name: SCREEN_NAME.POST_TYPE,
      start_time: parseInt(this.sessiontime.start_time)
    }
    this.analyticSdk.analyticService.ENTRY(entryData);
    /**
     * If feed is repost type then post type will be post.
     */
    if (this.dss.isRepostStatus === REPOST_STATUS.TWO && this.dss.repostProductType === PRODUCT_TYPE_CONSTANT.CME) {
      this.dss.posting_data.screen1.feed_kind = POST_TYPE.POST;
    } else if(this.dss.isRepostStatus === REPOST_STATUS.TWO && (this.dss.repostProductType ===  PRODUCT_TYPE_CONSTANT.WEBINAR ||
      this.dss.repostProductType ===  PRODUCT_TYPE_CONSTANT.FEED || this.dss.repostProductType ===  PRODUCT_TYPE_CONSTANT.DOCTALKS || this.dss.repostProductType ===  PRODUCT_TYPE_CONSTANT.ARTICLE)){
      this.dss.posting_data.screen1.feed_kind = POST_TYPE.REPOST;
    }

    if (this.dss.calling_from_community === NUMBERS.ONE && this.dss.posting_data.screen1.feed_kind !== FEED_KIND.POLL) {
      this.dss.posting_data.screen1.feed_kind = FEED_KIND.POST;
    }

  }

  /**
   * reset search box
   */
  resetSearchBox(): void {
    this.userFilter.speciality_name = '';

  }

  /**
   * get Speciality List
   */
  getSpecialityList(): void {
    this.api_in_process = true;
    this.subscriptions.add(this.getSer.getClinicalspecialityList().subscribe(resData => {
      this.api_in_process = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          if (data['code'] == 2000) {
            this.dss.speciality_list = data['data'].speciality_list;
            this.dss.posting_speciality_count = data['data'].posting_speciality_count;

            setTimeout(() => {
              if (this.dss.posting_data.screen2.selected_speciality.length == 0 && this.dss.speciality_list != undefined) {
                if (this.dss.speciality_list.length > NUMBERS.ZERO && this.dss.calling_from_community !== NUMBERS.ONE && this.dss.communityExists !== NUMBERS.ONE) {
                  this.dss.posting_data.screen2.selected_speciality = this.dss.speciality_list.filter(x => x.is_primary == 1);
                }
              }

              if (this.dss.posting_data.screen2.selected_speciality.length > NUMBERS.ZERO || this.dss.calling_from_community === NUMBERS.ONE || this.dss.isRepostStatus === REPOST_STATUS.TWO || this.dss.communityExists === NUMBERS.ONE ) {
                this.showColor = true;
              } else {
                this.showColor = false;
              }
            }, 800);
          }
        } else {
          this.fcs.errorHandeler(data);
        }
      });
    }));
  }

  /**
   * add speciality
   */
  addSpeciality(e, speData): boolean {
    this.err_msg = '';
    if (e.target.checked == true) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.POST_TYPE, CTA_TYPE.CHECKBOX, ACTION_TYPE.CLICK, ACTION_ON.SELECT_SPECIALITY_HASHTAG, null);
      if (this.dss.posting_data.screen2.selected_speciality.length > 2) {
        this.err_msg = 'You can select max ' + this.dss.posting_speciality_count + ' speciality';
        e.target.checked = false;
        return false;
      }
      this.dss.posting_data.screen2.selected_speciality.push(speData);
    } else {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.POST_TYPE, CTA_TYPE.CHECKBOX, ACTION_TYPE.CLICK, ACTION_ON.REMOVE_SPECIALITY_HASHTAG, null);
      this.removeSpeciality(speData, false);
    }
    if (this.dss.posting_data.screen2.selected_speciality.length > 0 || this.dss.isRepostStatus === REPOST_STATUS.TWO) {
      this.showColor = true;
    } else {
      this.showColor = false;
    }
  }

  /**
   * check speciality is selected or not
   */
  isSpecialitySelected(speData): boolean {

    // tslint:disable-next-line: radix
    const x = this.dss.posting_data.screen2.selected_speciality.filter(x => parseInt(x.speciality_id) == parseInt(speData.speciality_id));
    return (x.length > 0) ? true : false;
  }

  /**
   * remove selected speciality
   */
  removeSpeciality(speData, callAnalytics = true): void {
    if (callAnalytics) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.POST_TYPE, CTA_TYPE.ICON, ACTION_TYPE.CLICK, ACTION_ON.REMOVE_SPECIALITY_HASHTAG, null);
    }
    const index = this.dss.posting_data.screen2.selected_speciality.findIndex((item) => {
      return item.speciality_id == speData.speciality_id;
    });
    if (index != -1) {
      this.dss.posting_data.screen2.selected_speciality.splice(index, 1);
    }

    if (this.dss.posting_data.screen1.feed_kind == 'post' || this.dss.isRepostStatus === REPOST_STATUS.TWO) {
      setTimeout(() => {
        this.showColor = true;
      }, 5);
    } else {
      if (this.dss.posting_data.screen2.selected_speciality.length > 0) {
        this.showColor = true;
      } else {
        this.showColor = false;
      }
    }
  }

  /**
   * change Feed Kind
   */
  changeFeedKind(e): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.POST_TYPE, CTA_TYPE.TOGGLE, ACTION_TYPE.CLICK, ACTION_ON.POST_TYPE_TOGGLE, null);
    if (e.target.checked == true) {
      this.dss.posting_data.screen1.feed_kind = 'cases';
      if (this.dss.posting_data.screen2.selected_speciality.length > 0) {
        this.showColor = true;
      } else {
        this.showColor = false;
      }
    } else {
      this.dss.posting_data.screen1.feed_kind = 'post';
      this.showColor = true;
    }
  }

  /**
   * get User Association
   */
  getUserAssociation(): void {
    let repostParam = {
      product_id: NUMBERS.ZERO,
      product_type: NUMBERS.ZERO
    };
    if (this.dss.isRepostStatus === REPOST_STATUS.TWO) {
      repostParam = {
        product_id: this.dss.repostProductId,
        product_type: this.dss.repostProductType
      };
    }
    this.subscriptions.add(this.getSer.getUserAssociation(repostParam).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == NUMBERS.ONE) {
          if (data.code == STATUS_CODE.TWO_THOUSAND) {
            this.dss.user_association_list = data.data.user_association_list;
            if (this.dss.user_association_list.length == 1 && (this.dss.posting_data && this.dss.posting_data.feed_edit_mode && !(this.dss.posting_data.feed_edit_mode.feed_id))) {
              if (this.dss.posting_data.screen3.selected_association.indexOf(parseInt(this.dss.user_association_list[0].association_id, 10)) < 0) {
                this.dss.posting_data.screen3.selected_association.push(this.dss.user_association_list[0].association_id);
              }
            } else {
              if (this.dss.posting_data && this.dss.posting_data.feed_edit_mode && !(this.dss.posting_data.feed_edit_mode.feed_id)) {
                for (let i = 0; i < this.dss.user_association_list.length; i++) {
                  if (this.dss.user_association_list[i].is_public == '1' || this.dss.user_association_list[i].is_public == 1 || this.dss.isRepostStatus === REPOST_STATUS.TWO) {
                    if (this.dss.posting_data.screen3.selected_association.indexOf(parseInt(this.dss.user_association_list[i].association_id, 10) < 0)) {
                      this.dss.posting_data.screen3.selected_association.push(this.dss.user_association_list[i].association_id);
                    }
                  }

                }
              }
            }
            this.dss.posting_data.screen3.selected_association = [...new Set(this.dss.posting_data.screen3.selected_association)];
            if (this.dss.calling_from_community
              && !(this.dss.posting_data.feed_edit_mode.feed_id)) {
              this.dss.posting_data.screen3.selected_association = [];
            }
          }
        } else {
          this.fcs.errorHandeler(data);
        }
      }, () => {
        // Handle Error
      });
    }));
  }

  /**
   * upload File For Edit Feed Post
   */
  uploadFileForEditFeedPost(): void {
    this.postingService.uploadFileForEditFeedPost();
  }

  /**
   * upload File
   */
  uploadFile(): void {
    if (this.dss.posting_data.feed_edit_mode.is_edit == 1) {
      this.uploadFileForEditFeedPost(); return;
    }

    this.postingService.uploadFile();
  }

  /**
   * file Uploading Process
   */
  fileUploadingProcess(): void {
    this.nextPostScreen.emit(6.1);
    this.uploadFile();
  }

  /**
   * feed Post
   */
  feedPost(): void {
    this.postingService.feedPost();
  }

  /**
   * feed Edit Post
   */
  feedEditPost(): void {
    this.postingService.feedEditPost();
  }

  /**
   * call Next Screen
   */
  callNextScreen(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.POST_TYPE, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.NEXT, null);
    if (this.dss.user_association_list.length == 1 && this.dss.user_community_list.length == 0 && this.dss.isRepostStatus !== NUMBERS.TWO) {
      this.fileUploadingProcess();
    } else {
      this.nextPostScreen.emit(4);
    }
  }

  /**
   * get User Community
  */
  getUserCommunity(): void {
    const viewMoreOffset = '1'; // Flag to Check current offset for Community
    let repostParam = {};
    if (this.dss.isRepostStatus === REPOST_STATUS.TWO) {
      repostParam = {
        repost_product_id: this.dss.repostProductId,
        repost_product_type: this.dss.repostProductType
      };
    }
    this.subscriptions.add(this.getSer.getCommunityList(COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY, viewMoreOffset, '', repostParam, 'post_Box').subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status === NUMBERS.ONE) {
          if (data.code === STATUS_CODE.TWO_THOUSAND) {
            this.dss.user_community_list = resData.data.community_list[0]['list'];
          }
        }
      }, err => {
        console.log(err);
      });
    }));
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    /**
     * Set analytics end time.
     */
    this.sessiontime.end_time = new Date().getTime().toString();
    /**
     * Set analyics data on ngDestroy.
     */
    const exitData: EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.POSTING,
      entity_code: this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0',
      current_screen_name: SCREEN_NAME.POST_TYPE,
      start_time: parseInt(this.sessiontime.start_time),
      end_time: parseInt(this.sessiontime.end_time)
    }
    this.analyticSdk.analyticService.EXIT(exitData);
  }
}
